var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('h2',[_vm._v(_vm._s(_vm.detail.title))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.setTime(_vm.detail.publishAt)))]),_vm._v(" "),(_vm.detail.video)?_c('video'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.detail.cnt)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17a2e963","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/learning/detail.vue
// module id = null
// module chunks = 